import classNames from 'classnames'
import i18next from 'i18next'

class Input {
  constructor({
    textKey,
    ariaKey,
    id,
    tooltipPosition,
    validator,
    maxLength,
    onInputCallback,
    onKeyPressCallback,
  }) {
    this.id = id
    this.validator = validator
    this.node = null
    this.inputNode = null
    this.tooltipNode = null
    this.maxLength = maxLength
    this.onInputCallback = onInputCallback
    this.onKeyPressCallback = onKeyPressCallback
    this.input = {
      value: null,
    }
    this.label = {
      textKey: textKey,
      ariaKey: ariaKey,
      className: null,
    }
    this.tooltip = {
      position: tooltipPosition,
      error: null,
      className: null,
    }

    this.onKeyPress = this.onKeyPress.bind(this)
    this.onInput = this.onInput.bind(this)
    this.setValue = this.setValue.bind(this)
    this.checkErrors = this.checkErrors.bind(this)
    this.cleanErrors = this.cleanErrors.bind(this)
    this.mount = this.mount.bind(this)
  }

  setValue(value) {
    const inputNode = this.node.querySelector('input')

    if (!value) {
      this.input.value = null
      this.checkInputClassName()
      return (inputNode.value = this.input.value)
    }
    this.input.value = value
    this.checkInputClassName()
    inputNode.value = this.input.value
  }

  onInput(event) {
    this.input.value = event.target.value
    this.checkInputClassName()

    if (this.onInputCallback) {
      this.onInputCallback(event)
    }
  }

  onKeyPress(event) {
    if (event.key === 'Enter') this.checkErrors()

    if (!this.onKeyPressCallback) return

    this.onKeyPressCallback(event, this.node)
  }

  isLabelActive() {
    return (
      this.input.value &&
      (this.input.value.length > 0 || typeof this.input.value === 'number')
    )
  }

  checkInputClassName() {
    this.label.className = 'old-input-text__label'
    const inputNode = this.node.querySelector('input')
    inputNode.classList.remove('active')

    if (this.isLabelActive()) {
      this.label.className = 'old-input-text__label active'
      inputNode.classList.add('active')
    }

    this.node
      .querySelector('span')
      .setAttribute('class', `${this.label.className}`)
  }

  cleanErrors() {
    this.setSelectors()
    this.inputNode.classList.remove('error')
    this.tooltipNode.classList.remove('active')
  }

  addErrors() {
    this.setSelectors()
    this.inputNode.classList.add('error')
    this.tooltipNode.classList.add('active')
    this.node.querySelector('p').innerHTML = i18next.t(this.tooltip.error)
  }

  setSelectors() {
    this.tooltipNode = this.node.querySelector('.tooltip-text')
    this.inputNode = this.node.querySelector('input')
  }

  checkErrors() {
    this.tooltip.error = this.validator(this.input.value)
    this.cleanErrors()
    if (this.tooltip.error) {
      this.addErrors()
    }
  }

  addListener() {
    let input = this.node.querySelector('input')
    this.removeListener()

    input.addEventListener('input', this.onInput)
    input.addEventListener('blur', this.checkErrors)
    input.addEventListener('focus', this.cleanErrors)
    input.addEventListener('keypress', this.onKeyPress)

    i18next.on('languageChanged', this.mount)
  }

  removeListener() {
    let input = this.node.querySelector('input')
    input.removeEventListener('input', this.onInput)
    input.removeEventListener('blur', this.checkErrors)
    input.removeEventListener('focus', this.cleanErrors)
    input.removeEventListener('keypress', this.checkPostalcode)

    i18next.off('languageChanged', this.mount)
  }

  mount() {
    this.node = document.querySelector(`[input-text-id="${this.id}"]`)
    if (!this.node) {
      return
    }

    const labelClass = classNames('old-input-text__label', {
      active: this.isLabelActive(),
    })

    this.node.innerHTML = `
    <div class="tooltip">
      <span class="${labelClass}" i18n=${this.label.textKey}>
        ${i18next.t(this.label.textKey)}
      </span>
      <input
        class="${this.isLabelActive() && 'active'}"
        aria-label="${i18next.t(this.label.ariaKey)}"
        type="text"
        value="${this.input.value || ''}"
        maxlength="${this.maxLength}" >
      </input>
      <div class="tooltip-text ${this.tooltip.position}">
        <p></p>
      </div>
    </div>
    `
    this.addListener()
  }
}

export { Input }
